"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _pushDataLayer = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/utils/gtm/pushDataLayer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * When branch search returns no results
 * @param {string} screenName
 * @param {string} searchKeyword
 */
function noSearchResults(screenName) {
  var searchKeyword = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var eventData = {
    event: 'no_results_from_search',
    screen_name: screenName,
    search_keyword: searchKeyword
  };
  console.log('** gtm event no_results_from_search: ', eventData);
  (0, _pushDataLayer["default"])(eventData);
}
var _default = exports["default"] = noSearchResults;